import { createTheme, ThemeProvider } from '@mui/material';
import { Suspense, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Analytics } from './components/analytics/analytics';
import LoadingComponent from './core/componentLoading/loading';
import GenericRestCallContextProvider from './core/contexte/genericRestCallContext';
import URIParameterContextProvider from './core/contexte/URIParameterContext';
import GlobalErrorProvider from './core/globalErrorContext';
import ScrollToTop from './core/ScrollToTop/ScrollToTop';
import { ProjectPage } from './pages/projectPage';
import PrefillContextProvider from './core/contexte/prefillContext';
import DEFAULT_THEME from './themes/default_theme';
import { addCustomThemeProperties } from './themes/themeUtils';
import { UserEditedFieldsProvider } from './core/contexte/userEditedFieldsContext';
import { TrackingProvider } from './core/contexte/trackingContext';
import { ExternalFieldsConfigProvider } from './core/contexte/externalFieldsConfigContext';

function App() {
  const [theme, setTheme] = useState({});

  return (
    <BrowserRouter>
      <TrackingProvider>
        <GlobalErrorProvider>
          <URIParameterContextProvider>
            <ScrollToTop />
            <Analytics />
            <Suspense fallback={<LoadingComponent />}>
              <GenericRestCallContextProvider>
                <ExternalFieldsConfigProvider>
                  <ThemeProvider
                    theme={
                      theme
                        ? createTheme(addCustomThemeProperties(theme))
                        : createTheme(DEFAULT_THEME)
                    }
                  >
                    <PrefillContextProvider>
                      <UserEditedFieldsProvider>
                        <Routes>
                          <Route
                            element={<ProjectPage setTheme={setTheme} />}
                            path="/:project/*"
                          />
                        </Routes>
                      </UserEditedFieldsProvider>
                    </PrefillContextProvider>
                  </ThemeProvider>
                </ExternalFieldsConfigProvider>
              </GenericRestCallContextProvider>
            </Suspense>
          </URIParameterContextProvider>
        </GlobalErrorProvider>
      </TrackingProvider>
    </BrowserRouter>
  );
}

export default App;
